export enum CatalogOverridableField {
  UNIT_PRICE = "unitPrice",
  TAKEAWAY_PRICE = "takeawayPrice",
  PREP_STATION_ID = "prepStationId",
  BOOKKEEPING_ACCOUNT_ID = "bookkeepingAccountId",
  NAME = "name",
  ACCOUNT_NUMBER = "accountNumber",
  PRINTER_IDS = "printerIds",
  PRINTER_OVERRIDES = "printerOverrides",
  IS_MASTER = "isMaster",
  MIRRORED_PREP_STATION_IDS = "mirroredPrepStationIds",
  ENABLED = "enabled",
  PRIORITY = "priority",
}
